import { AloftPrice } from '@aloft/toolkit-shared';
import { Flex, Icon, Tooltip, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren, ReactNode } from 'react';

export const DepreciateSeparatelyModalContentPriceRowWrapper = ({
  children,
}: PropsWithChildren) => (
  <Flex flexDirection="column" paddingY="0.5rem">
    {children}
  </Flex>
);

export const DepreciateSeparatelyModalContentPriceRow = ({
  title,
  subtitle,
  informationTooltip,
  price,
}: {
  title: string;
  subtitle?: string;
  informationTooltip?: ReactNode;
  price?: AloftPrice;
}) => (
  <Flex justifyContent="space-between" padding="0.5rem" paddingLeft="0">
    <Flex gap=".25rem">
      <Typography variant="h4">{title}</Typography>
      <Flex marginTop=".125rem" marginLeft=".25rem">
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      </Flex>
      {informationTooltip && (
        <Tooltip label={informationTooltip}>
          <Icon size="sm" icon="information" />
        </Tooltip>
      )}
    </Flex>
    <Typography variant="h4">{price?.toString(true) ?? ''}</Typography>
  </Flex>
);
